/*
*   File : chip.js
*   Author : https://evoqins.com
*   Description :  Chip component
*   Integrations : NA
*   Version : 1.0.0
*/

import React from 'react';

const Chip = (props) => {
    return (
        <span className={`${props.fontSize ? props.fontSize : "e-font-12"} ${props.className}  mb-0 d-inline-flex border-radius-4  padding-6px-lr e-alt-font-lato e-font-weight-500 line-height-16px`}>
            {props.label}
        </span>
    )
}

export default Chip;
